<template>
  <el-dialog
    :title="!dataForm.id ? $t('upgradeRule.addRule') : $t('upgradeRule.editRule')"
    :close-on-click-modal="false"
    :visible.sync="visible"
    width="650px"
  >
    <el-form
      :model="dataForm"
      :rules="dataRule"
      ref="dataForm"
      @keyup.enter.native="dataFormSubmit()"
      label-width="100px"
    >
      <el-form-item :label="$t('upgradeRule.ruleName')" prop="upgradeName">
        <el-input v-model="dataForm.upgradeName" :placeholder="$t('upgradeRule.inputRuleName')"></el-input>
      </el-form-item>
      <el-form-item :label="$t('upgradeRule.upgradeType')" prop="upgradeType">
        <el-input v-model="dataForm.upgradeType" :placeholder="$t('upgradeRule.inputUpgradeType')"></el-input>
      </el-form-item>
      <el-form-item :label="$t('upgradeRule.upgradeDetails')" prop="upgradeDetails">
        <el-input
          type="textarea"
          v-model="dataForm.upgradeDetails"
          :rows="4"
          :placeholder="$t('upgradeRule.inputUpgradeDetails')"
        ></el-input>
      </el-form-item>
      <el-form-item :label="$t('upgradeRule.additionalCost')" prop="additionalCost">
        <el-input-number
          v-model="dataForm.additionalCost"
          :precision="2"
          :min="0"
          :step="10"
          controls-position="right"
        ></el-input-number>
        <span class="unit">{{ $t('common.yuan') }}</span>
      </el-form-item>
      <el-form-item :label="$t('upgradeRule.status')" prop="status">
        <el-select v-model="dataForm.status" :placeholder="$t('upgradeRule.selectStatus')">
          <el-option :label="$t('upgradeRule.enabled')" value="启用"></el-option>
          <el-option :label="$t('upgradeRule.disabled')" value="禁用"></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmit()">{{ $t('common.confirm') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      dataForm: {
        id: null,
        upgradeName: '',
        upgradeType: '',
        upgradeDetails: '',
        additionalCost: 0,
        status: '启用'
      },
      dataRule: {
        upgradeName: [
          { required: true, message: this.$t('upgradeRule.ruleNameRequired'), trigger: 'blur' }
        ],
        upgradeType: [
          { required: true, message: this.$t('upgradeRule.upgradeTypeRequired'), trigger: 'blur' }
        ],
        upgradeDetails: [
          { required: true, message: this.$t('upgradeRule.upgradeDetailsRequired'), trigger: 'blur' }
        ],
        additionalCost: [
          { required: true, message: this.$t('upgradeRule.additionalCostRequired'), trigger: 'blur' }
        ],
        status: [
          { required: true, message: this.$t('upgradeRule.statusRequired'), trigger: 'change' }
        ]
      }
    }
  },
  methods: {
    init(id) {
      this.dataForm.id = id || null
      this.visible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        if (this.dataForm.id) {
          this.$http({
            url: `/jiaolianyuyue/upgraderule/info/${this.dataForm.id}`,
            method: 'get',
            params: {}
          }).then(({ data }) => {
            if (data && data.code === 0) {
              this.dataForm.upgradeName = data.data.upgradeName
              this.dataForm.upgradeType = data.data.upgradeType
              this.dataForm.upgradeDetails = data.data.upgradeDetails
              this.dataForm.additionalCost = data.data.additionalCost
              this.dataForm.status = data.data.status
            }
          })
        }
      })
    },
    // 表单提交
    dataFormSubmit() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          this.$http({
            url: `/jiaolianyuyue/upgraderule/${!this.dataForm.id ? 'save' : 'update'}`,
            method: 'post',
            data: {
              id: this.dataForm.id || undefined,
              upgradeName: this.dataForm.upgradeName,
              upgradeType: this.dataForm.upgradeType,
              upgradeDetails: this.dataForm.upgradeDetails,
              additionalCost: this.dataForm.additionalCost,
              status: this.dataForm.status
            }
          }).then(({ data }) => {
            if (data && data.code === 0) {
              this.$message({
                message: '操作成功',
                type: 'success',
                duration: 1500,
                onClose: () => {
                  this.visible = false
                  this.$emit('refreshDataList')
                }
              })
            } else {
              this.$message.error(data.msg)
            }
          })
        }
      })
    }
  }
}
</script>

<style scoped>
.unit {
  margin-left: 10px;
}
</style> 